import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';

@Injectable()
export class Utils {
  constructor (
    private router: Router
  ) {}

  /**
   * create header for api requests
   * add Authorization token
   * other values for IE
   * @param parameterToken - if parameter exist, set localstorage
   */
  validateRoute() {
    const localStorageToken = String(localStorage.bertToken);

    if (localStorageToken === 'undefined') {
      this.router.navigate(['/authorization']);
    }
  }

  /**
   * Function to control the error messages according to
   * error code and error message from BE
   * @param status error code
   * @param errorMessage error message from BE
   */
  messageManager(status, errorMessage): string {
    let message = '';
    switch (status) {
      case 401:
        message = 'messages.error.401';
        break;
      case 404:
        if (errorMessage = 'API Key for this customer was not found') {
          message = 'messages.error.404-1';
        }
        break;
      default:
        message = 'messages.common.general-error';
    }
    return message;
  }

  handleActiveFilterStyle(inputFilters, renderer) {
    inputFilters.forEach(filter => {
      if (filter.nativeElement.value !== '') {
        renderer.addClass(filter.nativeElement, 'active-filter');
      } else {
      if (filter.nativeElement.classList.contains('active-filter')) {
        renderer.removeClass(filter.nativeElement, 'active-filter');
        }
      }
    });
  }

  /**
   * True for keys that never change an input's value.
   * Table filter inputs bind to (keyup), so navigation keys fire too.
   * Tabbing from one filter input to the next emits a filter change with
   * the new input's field, re-running the query and re-rendering the
   * table, which destroys the row a keyboard user has just tabbed into
   * and drops focus to "<body>". (WCAG 2.1.1)
   */
  isNonEditingKey(e: KeyboardEvent): boolean {
    const key = e.key;
    return key === 'Tab' || key === 'Shift' || key === 'Control' || key === 'Alt' ||
      key === 'Meta' || key === 'Escape' || key === 'Esc' ||
      key === 'ArrowLeft' || key === 'ArrowRight' || key === 'ArrowUp' || key === 'ArrowDown' ||
      key === 'Home' || key === 'End' || key === 'PageUp' || key === 'PageDown' ||
      key === 'CapsLock' || key === 'Insert';
  }
}
